export default __webpack_public_path__ + "static/media/c006-c.df8fe03a.jpg";